module.exports = __webpack_public_path__ + "static/img/about_cooperate_04_zh_h5.17f9299.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_cooperate_04_zh_h5.png
// module id = yRRF
// module chunks = 34